import React, { useEffect, useState } from "react";
import { Modal, Button } from "antd";

const DeleteMeetingDialog = ({
  visible,
  title,
  message,
  onOk,
  onCancel,
  currentMeeting,
}) => {
  const [occurred] = useState(false);
  const [selectedOption, setSelectedOption] = useState("1");
  const [isRecurrent, setIsRecurrent] = useState(false);

  //create useEffect and validate if currentMeeting is not occurred yet
  useEffect(() => {
    setSelectedOption("1");
    if (currentMeeting && currentMeeting.periodicity_group_id !== null) {
      setIsRecurrent(true);
    }
    else {
      setIsRecurrent(false);
    }
  }, [currentMeeting]);

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };

  return (
    <Modal
      open={visible}
      title={title}
      onCancel={onCancel}
      footer={
        [
          <Button key="ok" type="primary" onClick={()=>{onOk(selectedOption)}}>
            Aceptar
          </Button>,
          <Button key="cancel" onClick={onCancel}>
            Cancelar
          </Button>,
        ]
      }
    >
      <p>{message}</p>
    {isRecurrent && (
      <div>
        <div>
          <input
            id="delete1"
            type="radio"
            value="1"
            checked={selectedOption === "1"}
            onChange={handleChange}
            disabled={occurred}
          />
          <label htmlFor="delete1">Cancelar solo esta reunión</label>
        </div>
        <div>
          <input
            id="delete2"
            type="radio"
            value="2"
            checked={selectedOption === "2"}
            onChange={handleChange}
            disabled={occurred}
          />
          <label htmlFor="delete2">Cancelar esta y todas las reuniones futuras</label>
        </div>
        {/* <div>
          <input
            id="delete3"
            type="radio"
            value="3"
            checked={selectedOption === "3"}
            onChange={handleChange}
            disabled={occurred}
          />
          <label htmlFor="delete3">Cancelar todas las reuniones</label>
        </div> */}
      </div>
    )}
    </Modal>
  );
};

export default DeleteMeetingDialog;
